import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { alpha, useTheme } from '@material-ui/core';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import SectionHeader from '../../CherrySoftware/components/SectionHeader';
import GlassCard from '../../CherrySoftware/components/GlassCard';
import IconBadge from '../../CherrySoftware/components/IconBadge';
import { hubAbout, hubPillars } from '../mediaLabHubContent';

const HubPillars = () => {
  const theme = useTheme();

  return (
    <Box id="ecosistema" py={{ xs: 2, md: 3 }}>
      <SectionHeader
        overline={hubAbout.overline}
        title={hubAbout.title}
        subtitle={hubAbout.subtitle}
        icon="explore"
        maxWidth={760}
      />

      <SectionHeader
        overline={hubPillars.overline}
        title={hubPillars.title}
        subtitle={hubPillars.subtitle}
        icon="dashboard"
        maxWidth={720}
      />

      <Grid container spacing={3}>
        {hubPillars.items.map((item) => {
          const isExternal = Boolean(item.external || /^https?:\/\//i.test(item.href));
          const buttonProps = isExternal
            ? { href: item.href, target: '_blank', rel: 'noopener noreferrer' }
            : { component: RouterLink, to: item.href };

          return (
            <Grid item xs={12} sm={6} md={4} key={item.id}>
              <GlassCard
                data-aos="fade-up"
                accentPalette={item.color || 'primary'}
                sx={{
                  height: '100%',
                  display: 'flex',
                  flexDirection: 'column',
                  borderColor: item.featured
                    ? alpha(theme.palette.secondary.main, 0.35)
                    : undefined,
                  boxShadow: item.featured
                    ? `0 20px 48px ${alpha(theme.palette.secondary.main, 0.14)}`
                    : undefined,
                }}
              >
                <Box p={3} display="flex" flexDirection="column" height="100%">
                  <Box display="flex" alignItems="center" justifyContent="space-between" mb={2}>
                    <IconBadge
                      icon={item.icon}
                      color={item.color || 'primary'}
                      variant="gradient"
                      size={48}
                      rounded="14px"
                    />
                    <Typography
                      variant="caption"
                      sx={{
                        fontWeight: 800,
                        color: 'secondary.main',
                        letterSpacing: 0.4,
                      }}
                    >
                      {item.tag}
                    </Typography>
                  </Box>
                  <Typography variant="h6" sx={{ fontWeight: 800, mb: 1.25, lineHeight: 1.3 }}>
                    {item.title}
                  </Typography>
                  <Typography color="textSecondary" sx={{ lineHeight: 1.7, flex: 1, mb: 2.5 }}>
                    {item.text}
                  </Typography>
                  <Button
                    {...buttonProps}
                    variant={item.featured ? 'contained' : 'outlined'}
                    color={item.featured ? 'secondary' : 'primary'}
                    endIcon={<ArrowForwardIcon />}
                    sx={{ alignSelf: 'flex-start', fontWeight: 800, borderRadius: 2 }}
                  >
                    {item.cta}
                  </Button>
                </Box>
              </GlassCard>
            </Grid>
          );
        })}
      </Grid>
    </Box>
  );
};

export default HubPillars;
